export const debtorsReport = {
	title: "Cuentas Abiertas",
	filters: {
		vendor: "Vendor",
		period: "Período",
	},
	table: {
		title: "Informe de Cuentas Abiertas",
		filename: "informe_de_cuentas_abiertas__{{vendor}}__{{date}}",
		totalizer: {
			totalOpen: "Total Abierto",
			paidAfterEvent: "Pagado Después del Evento",
			clients: "Clientes",
			stillOpen: "Aún Abierto",
		},
		columns: {
			userName: "Nombre",
			userDocument: "CPF",
			phone: "Teléfono",
			totalOpen: "Total Abierto",
			paidAfterEvent: "Pagado Después del Evento",
			stillOpen: "Aún Abierto",
		},
	},
};
